import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {DumpsterFire} from "../DumpsterFire";
import {gsap} from "gsap";

export class DumpsterFireZeroBetIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    start(flowStateController: FlowStateController): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline({
            delay: 0.3,
            onComplete: () => {
                tl.kill();
            }
        });
        tl.add(() => {
            SlotGame.apiPlugin.betHandler.zeroBet();
            //freespinsLeft is missing from the init data in DumpsterFire, that's why this is here.
            if (!DumpsterFire.model.isRestore && DumpsterFire.model.data.upgradedSymbols.length > 0) {
                SlotGame.keypadPlugin.setZeroBetSpinCounter(DumpsterFire.model.gameData.freespinsLeft - 1);
            }
            flowStateController.finish();
        });
    }
}